import { render, staticRenderFns } from "./SimpleCampaigns_old.vue?vue&type=template&id=0138a502"
import script from "./SimpleCampaigns_old.vue?vue&type=script&lang=js"
export * from "./SimpleCampaigns_old.vue?vue&type=script&lang=js"
import style0 from "./SimpleCampaigns_old.vue?vue&type=style&index=0&id=0138a502&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports